const memoryMapper = {
    toDomain(data) {
        return {
            id: data.id,
            chapter: data.chapter,
            chapterTitle: data.chapterTitle,
            title: data.title,
            content: data.content,
            answerCount: data.answerCount
        };
    }
};

export {
    memoryMapper
};
